import React from "react";
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from "classnames";
import numeral from 'numeral';
// import moment from 'moment';
import withStyles from "@material-ui/core/styles/withStyles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Snackbar from '@material-ui/core/Snackbar';
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from '@material-ui/core/FormHelperText';
// import Tooltip from "@material-ui/core/Tooltip";

import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Parallax from "../../components/Parallax/Parallax.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import Table from "../../components/Table/Table.jsx";
import Quote from "../../components/Typography/Quote";

import SectionAuth from "../BookingFormPage/Sections/SectionAuth";
import FooterSection from "../LandingPage/Sections/FooterSection";
import CustomNotification from "../LandingPage/Sections/CustomNotification";

import DocTypes from "../../config/documentTypes.json"
import Countries from  "../../config/countries.json";

import bookingStyle from "../../assets/jss/material-kit-pro-react/views/bookingStyle.jsx";

import { saveUserBooking, bookTour } from '../../actions/toursActions';

class BookingFormTourPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showPayuButton: false,
            openNotification: false,
            messageNotification: '',
            variantNotification: '',
            checked: [1],
            documentTypeSelect: "0",
            countrySelect: "0",
            first_name: '',
            last_name: '',
            documentType: '',
            documentNumber: '',
            email: '',
            emailConfirmation: '',
            countryCode: '',
            phone: '',
            city: '',
            address: '',
            country: '',
            requirements: '',
            isFormCompleted: false,
            errors: {}
        };
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    componentWillMount() {
        const bookingInfo = JSON.parse(localStorage.getItem('BOOKING_INFO'));

        if (!!localStorage.getItem('BOOKING_INFO') && !!bookingInfo.start && !!bookingInfo.end) {
            // Do nothing
        } else {
            this.props.history.goBack();
        }

        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    };

    componentDidMount() {
        const { authReducer } = this.props;

        if (authReducer.isAuthenticated===true) {
            const { user } = authReducer;
            this.setState({ email: user.email, first_name: user.first_name, last_name: user.last_name, documentNumber: user.documentNumber });

            if ( !!localStorage.getItem('BOOKING_INFO') ) {
                let bookingInfo = JSON.parse(localStorage.getItem('BOOKING_INFO'));
                bookingInfo.tourist_id = user._id;
                localStorage.setItem('BOOKING_INFO', JSON.stringify(bookingInfo));
            }
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.errors !== this.state.errors) {
            /*
            TODO: Actualizar basado en login
            * */
            this.setState({ errors: newProps.errors });
            if (!!newProps.errors.message) this.handleClickNotification(newProps.errors.message, 'error');
        }

        if (newProps.authReducer.isAuthenticated===true) {
            const { user } = newProps.authReducer;
            if ( !!localStorage.getItem('BOOKING_INFO') ) {
                let bookingInfo = JSON.parse(localStorage.getItem('BOOKING_INFO'));
                bookingInfo.tourist_id = user._id;
                localStorage.setItem('BOOKING_INFO', JSON.stringify(bookingInfo));
            }
        }

        if (newProps.authReducer.isAuthenticated===true) {
            const { user } = newProps.authReducer;
            this.setState({ email: user.email, first_name: user.first_name, last_name: user.last_name, documentNumber: user.documentNumber });
        }
    };

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            this.setState({ [e.target.id]: e.target.value, errors: {} });
        } else if (!!e.target.name) {
            this.setState({ [e.target.name]: e.target.value, errors: {} });
        } else {
            this.handleClickNotification('Error actualizando la informacion ingresada', 'error');
        }
    };

    preventChangePayu = e => {
        e.preventDefault();

        alert("No puedes cambiar esta propiedad");
    };

    handleToggle = value => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
            this.setState({ showPayuButton: false });
        }

        this.setState({ checked: newChecked });
    };

    onSubmit = e => {
        e.preventDefault();

        const { authReducer } = this.props;
        const { documentType, documentNumber, countryCode, city, address, country, requirements, checked, errors } = this.state;

        if (checked.length > 0) {
            if (!!authReducer.user.documentType || documentType!=='') {
                if (!!authReducer.user.country || country!=='') {
                    let userInfo = {
                        _id: authReducer.user._id,
                        documentType: !!authReducer.user.documentType ? authReducer.user.documentType : documentType,
                        documentNumber: !!authReducer.user.documentNumber ? authReducer.user.documentNumber : documentNumber,
                        countryCode: !!authReducer.user.countryCode ? authReducer.user.countryCode : countryCode,
                        city: !!authReducer.user.city ? authReducer.user.city : city,
                        address: !!authReducer.user.address ? authReducer.user.address : address,
                        country: !!authReducer.user.country ? authReducer.user.country : country,
                        requirements: requirements!=='' ? requirements : !!authReducer.user.requirements ? authReducer.user.requirements : ''
                    };

                    this.props.saveUserBooking(userInfo);

                    if (!!errors.message) {
                        // Do nothing
                        // this.handleClickNotification(errors.message, 'error');
                    } else {
                        this.setState({ showPayuButton: true });
                        this.handleClickNotification('Datos verificados, puedes proceder al pago', 'success');
                        localStorage.setItem('SENDED_BOOKING_INFO', 'false');

                        if ( !!localStorage.getItem('BOOKING_INFO') ) {
                            let bookingInfo = JSON.parse(localStorage.getItem('BOOKING_INFO'));
                            this.props.bookTour(bookingInfo, userInfo);
                            this.handleClickNotification('Procesando...', 'success');
                            setTimeout(() => {
                                if (localStorage.getItem('PAYMENT_INFO')) {
                                    this.payuButton.click();
                                } else {
                                    this.handleClickNotification('Error generando la información de pago, por favor intenta nuevamente', 'error');
                                }
                            }, 4000);
                        }
                    }

                } else {
                    let errors = { country:"Selecciona un país" };
                    this.setState({ errors });
                }
            } else {
                let errors = { documentType:"Selecciona un tipo de documento" };
                this.setState({ errors });
            }
        } else {
            this.handleClickNotification('Debes aceptar los Términos y Condiciones', 'warning');
        }
    };

    cancelBook = (accommId) => {
        this.handleClickNotification('Cancelando reservación...', 'warning');
        setTimeout(() => {
            localStorage.removeItem('BOOKING_INFO');
            this.props.history.push('/tours');
        }, 2000);
    };

    render() {
        const { classes, authReducer } = this.props;
        const { errors } = this.state;

        let bookingInfo;

        if (!!JSON.parse(localStorage.getItem('BOOKING_INFO'))) {
            bookingInfo = JSON.parse(localStorage.getItem('BOOKING_INFO'));
        } else {
            this.props.history.goBack();
        }

        let tourToBookList = [];

        tourToBookList.push([
            <span>{bookingInfo.tourName}</span>,
            <span>{bookingInfo.persons}</span>,
            <span>{bookingInfo.start}</span>,
            <span>{bookingInfo.end}</span>,
            <span>{numeral(bookingInfo.totalPrice).format('0,0')}</span>,
            <Button onClick={() => this.cancelBook(bookingInfo.tourId)} simple justIcon size="sm" color="danger"> <Close /> </Button>
        ]);

        // Table footer (Total price)
        authReducer.isAuthenticated===true ?
             tourToBookList.push([
                 <span></span>,
                 <span></span>,
                 <span></span>,
                 <span><strong>Subtotal:</strong></span>,
                 <span><small>COP$</small> {numeral(bookingInfo.totalPrice).format('0,0')}</span>,
                 <span></span>
             ],[
                 <span></span>,
                 <span></span>,
                 <span></span>,
                 <span><strong>I.V.A.</strong></span>,
                 <span><small>COP$</small> {numeral(bookingInfo.tax).format('0,0')}</span>,
                 <span></span>
             ],[
                 <span></span>,
                 <span></span>,
                 <span></span>,
                 <span className={classes.totalPrice}><strong>Total</strong></span>,
                 <span className={classes.totalPrice}><small>COP$</small> {numeral(bookingInfo.totalPrice+bookingInfo.tax).format('0,0')}</span>,
                 <span></span>
             ])
            :
            null;


        !!this.props.toursReducer.paymentInfo ?
            localStorage.setItem('PAYMENT_INFO', JSON.stringify(this.props.toursReducer.paymentInfo))
            :
            null;

        return (
            <div className={classes.productPage}>
                {/* Custom Notification */}
                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                    <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                </Snackbar>
                {/* End Custom Notification */}

                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Reservar Tour | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/booking-tour" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 150,
                        color: "white"
                    }}
                />
                <Parallax
                    image={require("../../assets/img/landing-bg.jpg")}
                    filter="success"
                    className={classes.pageHeader}
                >
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.contactContent}>
                        <div className={classes.container}>

                            <h2 className={classes.title}>Reservación de Tour</h2>

                            {/* Booked Product Table */}
                            {authReducer.isAuthenticated===true ?
                                <CardBody plain>
                                    <h3 className={classes.cardTitle}>Detalles de la Reservación</h3>
                                    <Table
                                        tableShopping
                                        tableHead={[ "Tour", "No. Personas", "Check-In", "Check-Out", "Precio ($COP)", "" ]}
                                        tableData={ tourToBookList }
                                        customHeadCellClasses={[ classes.textCenter, classes.textCenter, classes.textCenter, classes.textCenter, classes.textCenter, classes.textCenter ]}
                                        customHeadClassesForCells={[0, 1, 2, 3, 4, 5]}
                                        customCellClasses={[ classes.description, classes.textCenter, classes.textCenter, classes.textCenter, classes.textCenter, classes.textCenter ]}
                                        customClassesForCells={[0, 1, 2, 3, 4, 5]}
                                    />
                                </CardBody>
                                :
                                null
                            }
                            {/* End Booked Product Table */}

                            <div className={classes.clarificationQuote}>
                                <Quote text="NOTA: Recuerda que tienes un plazo de 24 horas para realizar el pago de la reservación, de lo contrario, ésta se cancelará" />
                            </div>

                            <h4 className={classes.title}>Tu información personal</h4>

                            {authReducer.isAuthenticated ?
                                (
                                    <div>
                                        <form onSubmit={this.onSubmit}>
                                            <GridContainer>
                                                <GridItem md={6} sm={6}>
                                                    <p><strong>Nombre(s):</strong> {authReducer.user.first_name}</p>
                                                </GridItem>
                                                <GridItem md={6} sm={6}>
                                                    <p><strong>Apellidos:</strong> {authReducer.user.last_name}</p>
                                                </GridItem>
                                                <GridItem md={6} sm={6}>
                                                    <p><strong>Email:</strong> {authReducer.user.email}</p>
                                                </GridItem>
                                                {!!authReducer.user.documentType ?
                                                    <GridItem md={6} sm={6}> <p><strong>Tipo de documento:</strong> {authReducer.user.documentType}</p> </GridItem> : null
                                                }
                                                {!!authReducer.user.documentNumber ?
                                                    <GridItem md={6} sm={6}> <p><strong>Número de documento:</strong> {authReducer.user.documentNumber}</p> </GridItem> : null
                                                }
                                                {!!authReducer.user.contact_info.phones.length>0 ?
                                                    authReducer.user.contact_info.phones.map((phone, index) => {
                                                        return <GridItem md={6} sm={6} key={phone+index}> <p><strong>Teléfono {index+1}:</strong> {!!authReducer.user.countryCode ? `+${authReducer.user.countryCode}` : ''} {phone}</p> </GridItem>
                                                    })
                                                    :
                                                    null
                                                }
                                                {!!authReducer.user.contact_info.mobile.length>0 ?
                                                    authReducer.user.contact_info.mobile.map((mobile, index) => {
                                                        return <GridItem md={6} sm={6} key={mobile+index}> <p><strong>Teléfono móvil {index+1}:</strong> {mobile}</p> </GridItem>
                                                    })
                                                    :
                                                    null
                                                }
                                                {!!authReducer.user.city ?
                                                    <GridItem md={6} sm={6}> <p><strong>Ciudad:</strong> {authReducer.user.city}</p> </GridItem> : null
                                                }
                                                {!!authReducer.user.address ?
                                                    <GridItem md={6} sm={6}> <p><strong>Dirección:</strong> {authReducer.user.address}</p> </GridItem> : null
                                                }
                                                {!!authReducer.user.country ?
                                                    <GridItem md={6} sm={6}> <p><strong>País:</strong> {authReducer.user.country}</p> </GridItem> : null
                                                }
                                            </GridContainer>
                                            <br/>
                                            <br/>
                                            <GridContainer>

                                                <GridItem md={12} sm={12}>
                                                    <p>Todos los campos con * son obligatorios</p>
                                                </GridItem>

                                                {!authReducer.user.documentType ?
                                                    <GridItem md={6} sm={6}>
                                                        <FormControl fullWidth className={classes.selectFormControl}>
                                                            <InputLabel htmlFor="documentType" className={classes.selectLabel}> Tipo de documento * </InputLabel>
                                                            <Select
                                                                MenuProps={{ className: classes.selectMenu }}
                                                                classes={{ select: classes.select }}
                                                                value={this.state.documentType}
                                                                onChange={this.onChangeCustomInput()}
                                                                inputProps={{
                                                                    id: "documentType",
                                                                    name: "documentType"
                                                                }}
                                                            >
                                                                {DocTypes.map(docType =>
                                                                    <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} key={docType.code} value={docType.name}>
                                                                        {docType.name}
                                                                    </MenuItem>
                                                                )}
                                                            </Select>
                                                            {!!errors.documentType ? <FormHelperText className={classes.errorDisplay}>{errors.documentType}</FormHelperText> : null}
                                                        </FormControl>
                                                    </GridItem>
                                                    :
                                                    null
                                                }

                                                {!authReducer.user.documentNumber ?
                                                    <GridItem md={6} sm={10}>
                                                        <CustomInput
                                                            id = "documentNumber"
                                                            formControlProps={{ fullWidth: true }}
                                                            labelText= {!!errors.documentNumber ? errors.documentNumber : "No. Documento *"}
                                                            error = {!!errors.documentNumber}
                                                            inputProps={{
                                                                value: this.state.documentNumber,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                    </GridItem>
                                                    :
                                                    null
                                                }

                                                {!authReducer.user.countryCode ?
                                                    <GridItem md={6} sm={10}>
                                                        <CustomInput
                                                            id = "countryCode"
                                                            formControlProps={{ fullWidth: true }}
                                                            labelText= {!!errors.countryCode ? errors.countryCode : "Código del país"}
                                                            error = {!!errors.countryCode}
                                                            inputProps={{
                                                                value: this.state.countryCode,
                                                                onChange: this.onChangeCustomInput()
                                                                // ,required: true
                                                            }}
                                                        />
                                                    </GridItem>
                                                    :
                                                    null
                                                }

                                                {(authReducer.user.contact_info.phones.length===0 && authReducer.user.contact_info.mobile.length===0) ?
                                                    <GridItem md={6} sm={10}>
                                                        <CustomInput
                                                            id = "phone"
                                                            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                                            formControlProps={{ fullWidth: true }}
                                                            labelText= {!!errors.phone ? errors.phone : "Teléfono o móvil *"}
                                                            error = {!!errors.phone}
                                                            inputProps={{
                                                                value: this.state.phone,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                    </GridItem>
                                                    :
                                                    null
                                                }

                                                {!authReducer.user.city ?
                                                    <GridItem md={6} sm={10}>
                                                        <CustomInput
                                                            id = "city"
                                                            formControlProps={{ fullWidth: true }}
                                                            labelText= {!!errors.city ? errors.city : "Ciudad *"}
                                                            error = {!!errors.city}
                                                            inputProps={{
                                                                value: this.state.city,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                    </GridItem>
                                                    :
                                                    null
                                                }

                                                {!authReducer.user.address ?
                                                    <GridItem md={6} sm={10}>
                                                        <CustomInput
                                                            id = "address"
                                                            formControlProps={{ fullWidth: true }}
                                                            labelText= {!!errors.address ? errors.address : "Dirección *"}
                                                            error = {!!errors.address}
                                                            inputProps={{
                                                                value: this.state.address,
                                                                onChange: this.onChangeCustomInput(),
                                                                required: true
                                                            }}
                                                        />
                                                    </GridItem>
                                                    :
                                                    null
                                                }

                                                {!authReducer.user.country ?
                                                    <GridItem md={6} sm={6}>
                                                        <FormControl fullWidth className={classes.selectFormControl}>
                                                            <InputLabel htmlFor="country" className={classes.selectLabel}> País * </InputLabel>
                                                            <Select
                                                                MenuProps={{ className: classes.selectMenu }}
                                                                classes={{ select: classes.select }}
                                                                value={this.state.country}
                                                                onChange={this.onChangeCustomInput()}
                                                                inputProps={{
                                                                    id: "country",
                                                                    name: "country"
                                                                }}
                                                            >
                                                                {Countries.map(country => {
                                                                    return <MenuItem classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }} key={country.code} value={country.name}>
                                                                        {country.name}
                                                                    </MenuItem>
                                                                })}
                                                            </Select>
                                                            {!!errors.country ? <FormHelperText className={classes.errorDisplay}>{errors.country}</FormHelperText> : null}
                                                        </FormControl>
                                                    </GridItem>
                                                    :
                                                    null
                                                }

                                                <GridItem md={12} sm={6}>
                                                    <CustomInput
                                                        id = "requirements"
                                                        formControlProps={{ fullWidth: true }}
                                                        labelText= {!!errors.requirements ? errors.requirements : "Requerimientos Adicionales"}
                                                        error = {!!errors.requirements}
                                                        inputProps={{
                                                            multiline: true,
                                                            rows: 6,
                                                            value: this.state.requirements,
                                                            onChange: this.onChangeCustomInput()
                                                            // ,required: true
                                                        }}
                                                    />

                                                    <FormControlLabel
                                                        classes={{ label: classes.label }}
                                                        control={
                                                            <Checkbox
                                                                tabIndex={-1}
                                                                onClick={() => this.handleToggle(1)}
                                                                checkedIcon={ <Check className={classes.checkedIcon} /> }
                                                                icon={ <Check className={classes.uncheckedIcon} /> }
                                                                classes={{ checked: classes.checked }}
                                                                checked={ this.state.checked.indexOf(1) !== -1 }
                                                            />
                                                        }
                                                        label={ <span> Al continuar, acepto los <a href="/terminos-y-condiciones" target="_blank">Términos y Condiciones.</a>. </span> }
                                                    />
                                                </GridItem>
                                            </GridContainer>

                                            {this.state.showPayuButton===false ?
                                                <div className={classes.textCenter}>
                                                    <Button color="success" type="submit">
                                                        Confirmar reservación
                                                    </Button>
                                                </div>
                                                :
                                                null
                                            }
                                        </form>

                                        {/* PayU form */}
                                        {!!localStorage.getItem('PAYMENT_INFO') ?
                                            <form method="post" action={JSON.parse(localStorage.getItem('PAYMENT_INFO')).serviceUrl}>
                                                <div className={classes.hidden}>
                                                    <input name="merchantId" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).merchantId} onChange={e => this.preventChangePayu} />
                                                    <input name="accountId" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).accountId} onChange={e => this.preventChangePayu} />
                                                    {!!bookingInfo.persons ?
                                                        <input name="description" value={`${JSON.parse(localStorage.getItem('PAYMENT_INFO')).description}, ${bookingInfo.tourName}, ${bookingInfo.persons} pasajeros, ${bookingInfo.start}`} onChange={e => this.preventChangePayu} />
                                                        :
                                                        <input name="description" value={`${JSON.parse(localStorage.getItem('PAYMENT_INFO')).description}, ${bookingInfo.tourName}, ${bookingInfo.start} - ${bookingInfo.end}`} onChange={e => this.preventChangePayu} />
                                                    }
                                                    <input name="referenceCode" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).referenceCode} onChange={e => this.preventChangePayu} />
                                                    <input name="amount" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).amount} onChange={e => this.preventChangePayu} />
                                                    {/*<input name="tax" value="COP" />*/}
                                                    {/*<input name="taxReturnBase" value="723e417a4aeb2bef46c80fb21033294edf8edd5aa4e1b7cbffe2d30c2a1c90b3" >*/}
                                                    <input name="currency" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).currency} onChange={e => this.preventChangePayu} />
                                                    <input name="signature" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).signature} onChange={e => this.preventChangePayu} />
                                                    <input name="test" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).test} onChange={e => this.preventChangePayu} />
                                                    <input name="buyerEmail" value={this.state.email} onChange={e => this.preventChangePayu} />
                                                    <input name="buyerFullName" value={`${this.state.first_name} ${this.state.last_name}`} onChange={e => this.preventChangePayu} />
                                                    <input name="payerDocument" value={this.state.documentNumber} onChange={e => this.preventChangePayu} />
                                                    <input name="responseUrl" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).responseUrl} onChange={e => this.preventChangePayu} />
                                                    <input name="confirmationUrl" value={JSON.parse(localStorage.getItem('PAYMENT_INFO')).confirmationUrl} onChange={e => this.preventChangePayu} />
                                                </div>
                                                <div className={classes.textCenter}>
                                                    <button ref={elem => this.payuButton = elem} type="submit" style={{display:"none"}}>Ir al Pago</button>
                                                </div>
                                            </form>
                                            :
                                            null
                                        }
                                        {/* End PayU form */}
                                    </div>
                                )
                                :
                                <SectionAuth />
                            }
                        </div>
                    </div>
                </div>
                <div className={classes.main}>
                    <FooterSection/>
                </div>
            </div>
        );
    }
}

BookingFormTourPage.propTypes = {
    saveUserBooking: PropTypes.func.isRequired,
    bookTour: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired,
    toursReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    authReducer: state.authReducer,
    toursReducer: state.toursReducer,
    errors: state.errors
});

// Function to replace characters in strings
String.prototype.replaceAll = function(search, replacement) {
    let target = this;
    return target.split(search).join(replacement);
};

export default connect(mapStateToProps, { saveUserBooking, bookTour })( withStyles(bookingStyle)(BookingFormTourPage) );



// WEBPACK FOOTER //
// ./src/views/BookingFormTourPage/BookingFormTourPage.jsx